import type { AppProps } from 'next/app';
import dynamic from 'next/dynamic';
import '../styles/globals.css';
import '../styles/loading.css';
import '@zillow/constellation-fonts/zillow-fonts.css';
import { RpErrorBoundary, useBootstrap } from '@zg-rentals/rp-bootstrap-browser';
import { setClient as setCappsClient } from '@zg-rentals/ts-capps-client/client';
import { setClient as setIdVerificationClient } from '@zg-rentals/ts-id-verification-client/client';
import { setClient as setRentalManagerApiBetaClient } from '@zg-rentals/ts-rental-manager-api-client/client';
import { getClient } from '@zg-rentals/ts-client-http-client';
import { Head } from '@zg-rentals/next/pages';
import { ToastProvider } from '@zillow/constellation-10';
import { BASE_URL } from '../constants/urls';
import { DefaultQueryProvider } from '@zg-rentals/react-query5';
import { Auth } from '../AuthProvider';
import { ServerErrorPage } from './500';

const NoSsrApp = dynamic(() => import('../components/App'), { ssr: false });

setCappsClient(getClient().extend({ prefixUrl: process.env.NEXT_PUBLIC_RENTAL_PREFIX_URL }));
setIdVerificationClient(getClient().extend({ prefixUrl: process.env.NEXT_PUBLIC_RENTAL_PREFIX_URL }));
setRentalManagerApiBetaClient(getClient().extend({ prefixUrl: BASE_URL }));

const ApplicationsLandlordWeb = (appProps: AppProps) => {
  useBootstrap(() => import('../bootstrap/browser'));

  return (
    <>
      <Head applicationName="applications-landlord-web" buildRef={process.env.NEXT_PUBLIC_BUILD_REF}>
        <title>Rental Applications | Zillow</title>
      </Head>

      <DefaultQueryProvider
        defaultOptions={{
          queries: {
            retry: false,
            refetchOnWindowFocus: false,
            staleTime: 1000 * 60 * 30, // 30 minutes
          },
        }}
        mutationErrorContext={() => undefined} // Note: disable serializing mutation variables
      >
        <Auth.Provider>
          <ToastProvider>
            <RpErrorBoundary fallback={<ServerErrorPage />}>
              <NoSsrApp appProps={appProps} />
            </RpErrorBoundary>
          </ToastProvider>
        </Auth.Provider>
      </DefaultQueryProvider>
    </>
  );
};

export default ApplicationsLandlordWeb;
